<template>
  <div class="container-login d-flex align-items-center">
    <div class="card card-login card-register align-items-stretch my-5">
      <div class="card-login-logo text-center pt-4">
        <img src="../../img/vendoscope-logo.png">
      </div>

      <div class="card-body d-flex flex-column">
        <personal-user class="mb-1" v-model="user" :showThirdName="false" :showPhone="false" :showTitle="true" :titleContext="Регистрация"/>

        <personal-organization class="mb-1" v-model="organization" :shortForm="true"/>

        <btn-action class="btn btn-primary btn-lg mt-2" @click="save">Зарегистрировать</btn-action>
        <div class="alert alert-danger mt-2" v-if="validationError">
          {{validationError}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import PersonalUser from '../components/personal/user.vue'
  import PersonalOrganization from '../components/personal/organization.vue'

  export default {
    metaInfo: {title: 'Регистрация'},
    components: {PersonalUser, PersonalOrganization},
    data () {
      return {
        user: {},
        organization: {},
        signer: {},
        validationError: '',
      }
    },
    methods: {
      save () {
        return this.$validator.validateAll().then(success => {
          if (success) {
            return api.post('organizations', {
              user: this.user,
              organization: Object.assign(this.organization, {signer: this.signer}),
            })
              .then(() => this.$router.push(({ path: 'login', query: { email: this.user.email } })))
              .catch((error) => {
                if (error.response && error.response.status === 422) {
                  let obj = error.response.data.validation
                  this.validationError = obj[Object.keys(obj)[0]][0]
                } else {
                  throw error
                }
              })
          }
        })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/register.vue